module.exports = __webpack_public_path__ + "files/9bc01fec3668d6f5d2787e45a70771bd.svg";